import {
  AlertDialog,
  AlertDialogBackdrop,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
} from '@/components/ui/alert-dialog'
import { Button, ButtonText } from '@/components/ui/button'
import { Heading } from '@/components/ui/heading'
import { Text } from '@/components/ui/text'
import storage from '@/lib/storage'
import { router, usePathname } from 'expo-router'
import { useEffect, useState } from 'react'
import { BackHandler, Platform } from 'react-native'

const PRIVACY_CONSENT_KEY = 'privacy_policy_agreed'

const LEGAL_PATHS = ['/privacy', '/terms', '/usage_specification']

function hasPrivacyConsent(): boolean {
  return storage.get<boolean>(PRIVACY_CONSENT_KEY) === true
}

function isLegalPath(pathname: string): boolean {
  return LEGAL_PATHS.some(p => pathname === p || pathname.startsWith(`${p}/`))
}

export default function PrivacyConsentDialog() {
  const [consented, setConsented] = useState(() => hasPrivacyConsent())
  const pathname = usePathname()

  // Hide the dialog while the user is reading a legal page so the page isn't
  // covered by the alert modal; restore it when they navigate back.
  const visible = Platform.OS === 'android' && !consented && !isLegalPath(pathname)

  useEffect(() => {
    if (!visible) return

    // Block Android back button while dialog is shown
    const handler = BackHandler.addEventListener('hardwareBackPress', () => true)
    return () => handler.remove()
  }, [visible])

  if (Platform.OS !== 'android' || consented) return null

  const handleAgree = () => {
    storage.set(PRIVACY_CONSENT_KEY, true)
    setConsented(true)
  }

  const handleExit = () => {
    BackHandler.exitApp()
  }

  return (
    <AlertDialog isOpen={visible} onClose={() => {}} size="md">
      <AlertDialogBackdrop />
      <AlertDialogContent>
        <AlertDialogHeader className="justify-center">
          <Heading size="lg">温馨提示</Heading>
        </AlertDialogHeader>
        <AlertDialogBody className="pt-4">
          <Text className="leading-6">
            欢迎您使用金数据APP！我们非常重视您的个人信息和隐私保护，我们将通过
            <Text className="text-primary-600" onPress={() => router.push('/(leagal)/privacy')}>
              《隐私权保护政策》
            </Text>
            帮助您了解我们收集、使用、存储、共享和保护个人信息的情况，以及您所享有的相关权利。
          </Text>
          <Text className="leading-6 mt-3">
            请您阅读并了解
            <Text className="text-primary-600" onPress={() => router.push('/(leagal)/terms')}>
              《使用条款》
            </Text>
            和
            <Text className="text-primary-600" onPress={() => router.push('/(leagal)/privacy')}>
              《隐私政策》
            </Text>
          </Text>
        </AlertDialogBody>
        <AlertDialogFooter className="flex-col gap-2 pt-4">
          <Button onPress={handleAgree} className="w-full">
            <ButtonText>同意并进入</ButtonText>
          </Button>
          <Button variant="link" action="secondary" onPress={handleExit}>
            <ButtonText>退出</ButtonText>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
